var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BackLink',{staticClass:"mb-10",attrs:{"text":_vm.$t("auth.nav.office"),"noaction":true},nativeOn:{"click":function($event){return _vm.$router.push('/login')}}}),_c('MapComponent',{staticClass:"mb-10"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }